module.exports = __webpack_public_path__ + "static/media/cup_silver.b7302d44.png";